import React from "react";
import "../sass/video.sass";

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2022</p>
    </footer>
  );
};

export default Footer;
